// 如果对此文件进行变更，记得手动增加 version 版本号 否则 tables 的改动会无效
// 中控参考: src/share/indexDB/db-config.js
export default {
  dbName: 'helios',
  version: 1,
  tables: [
    {
      tableName: 'coreProcess', // 漏斗table
      option: { keyPath: 'UUID' }, //主健
    },
    {
      tableName: 'eventStack', // 埋点table
      option: { keyPath: 'UUID' }, //主健
    },
    {
      tableName: 'logTable', // 诊断期间 jsError routeChange httpFetch table
      option: { keyPath: 'UUID' }, //主健
    },
  ],
};
